import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const ipFilterOperators = unreadonly([
  ...filterOperators.ip,
  ...filterOperators.cidr,
  ...filterOperators.empty,
  ...filterOperators.regexCaseSensitive,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type IpFilterOperator = (typeof ipFilterOperators)[number];

export type IpTableFilter = TableFilterBase & {
  type: 'ip';
};

export const createIpFilter = (): IpTableFilter => ({
  type: 'ip',
  operators: ipFilterOperators,
});
